import packageJson from "../../../package.json";

import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";

type AppFooterVariant = "compact" | "highlight";

interface AppFooterProps {
  variant?: AppFooterVariant;
  className?: string;
}

const CURRENT_YEAR = new Date().getFullYear();

export function AppFooter({ variant = "compact", className }: AppFooterProps) {
  const appVersion = packageJson.version;
  const isHighlight = variant === "highlight";
  const { t } = useLanguage();

  return (
    <footer
      className={cn(
        "text-clinic-text-muted",
        isHighlight
          ? "rounded-2xl border border-clinic-border/70 bg-clinic-surface/75 px-4 py-3 backdrop-blur-sm"
          : "border-t border-clinic-border/70 pt-4",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:text-left">
        <div className="flex items-center gap-3">
          <a
            href="https://www.optimusinttec.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-full border border-clinic-primary/15 bg-clinic-primary/8 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-clinic-primary transition-all hover:scale-[1.02] hover:bg-clinic-primary/15"
          >
            Optimus
          </a>
          <span className="hidden h-1 w-1 rounded-full bg-clinic-text-muted/60 sm:block" />
          <p className="text-sm">
            {t("Desenvolvido por")}{" "}
            <span className="font-medium text-clinic-text">Optimus Inteligência e Tecnologia</span>
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs uppercase tracking-[0.18em] sm:justify-end">
          <span>{CURRENT_YEAR}</span>
          <span className="hidden h-1 w-1 rounded-full bg-clinic-text-muted/60 sm:block" />
          <span>{t(`Versão ${appVersion}`)}</span>
        </div>
      </div>
    </footer>
  );
}
